import React, { useContext, useEffect, useState } from 'react';
import { format } from 'date-fns-tz';
import PropTypes from 'prop-types';
import { Button, Loader, Table, Modal, Alert } from '@itds/elements/index.js';

import { AgencyContext } from '@brokerage/contexts/AgencyContext';

import { Api } from '@brokerage/utils/Api';

const Devices = ({ mobile_app }) => {
  const { member_emails } = useContext(AgencyContext);

  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [action, setAction] = useState(null);
  const [success_message, setSuccessMessage] = useState();
  const [error_message, setErrorMessage] = useState();

  useEffect(() => {
    loadDevices();
  }, []);

  const loadDevices = () => {
    setLoading(true);

    Api.loadMobileDevices({ mobile_app_id: mobile_app.id }).then(({ data }) => {
      setData(data);
      setLoading(false);
    });
  };

  const handleDelete = (device, e) => {
    setModal('delete');
    setAction(device);
    e.stopPropagation();
  };

  const confirmDelete = () => {
    setLoading(true);
    window.scrollTo(0, 0);

    Api.deleteMobileDevice(action.id)
      .then(() => {
        setModal(null);
        setAction(null);
        loadDevices();
        setSuccessMessage('Mobile Device deleted');
        setTimeout(() => {
          setSuccessMessage(null);
        }, 2000);
      })
      .catch(() => {
        setAction(null);
        setModal(null);
        setErrorMessage('Unable to delete the Mobile Device at this time');
        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
  };

  return loading ? (
    <Loader />
  ) : (
    <div>
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      <Table
        columns={[
          {
            label: 'Device Name',
            id: 'device_type_name'
          },
          {
            label: 'Platform',
            id: 'device_type_platform'
          },
          {
            label: 'Version',
            id: 'device_type_version'
          },
          {
            label: 'Created On',
            id: 'created_at',
            width: 220,
            render: device => format(new Date(device.created_at), 'MMM do, yyyy @ h:mm aaa z')
          },
          {
            label: 'Member',
            id: 'member_id',
            render: device => {
              const member = member_emails.find(m => m.value === device.member_id);

              return member ? member.label : null;
            }
          },
          {
            label: 'Player ID',
            id: 'onesignal_player_id'
          },
          {
            id: 'actions',
            render: device => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, device)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={data}
        placeholder='No Mobile Devices Yet'
      />
      {modal === 'delete' ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
            setAction(null);
          }}
          title={`Delete "${action.device_type_name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete device "{action.device_type_name}"?
          </div>
        </Modal>
      ) : null}
    </div>
  );
};

Devices.propTypes = {
  mobile_app: PropTypes.object
};

export default Devices;
